import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

const APP_STORE_URL = 'https://apps.apple.com/us/app/rosie-ai-business-receptionist/id6757593086';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.rosie.mobile';

/**
 * Bridge page for mobile email verification.
 *
 * Custom-scheme links (rosie://) are not clickable from email clients — they only
 * linkify http(s)/mailto — so the verification email points here over https (which
 * IS clickable), and this page hands off to the app's deep link, which resolves
 * fine from a browser context. The code is shown as a visible fallback for when the
 * app isn't installed or the hand-off is blocked (e.g. desktop).
 */
@Component({
  selector: 'rosie-app-email-verify',
  templateUrl: './app-email-verify.component.html',
  styleUrls: ['./app-email-verify.component.scss'],
  standalone: false,
})
export class AppEmailVerifyComponent implements OnInit {
  code = '';
  readonly appStoreUrl = APP_STORE_URL;
  readonly playStoreUrl = PLAY_STORE_URL;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.code = this.route.snapshot.queryParamMap.get('code') || '';
    this.openApp();
  }

  openApp(): void {
    if (!this.code) {
      return;
    }
    window.location.href = `rosie:///auth/email-verification?code=${encodeURIComponent(this.code)}`;
  }
}
